export const RPC_INDEX_KEY = 'rpc_index';

export const WALLET_ID_KEY = 'walletId';
